import type { TomDoConfirmar } from "@base/ui";

export type PedidoDeAvisoApi = {
  readonly titulo: string;
  readonly descricao: string;
  readonly rotuloConfirmar?: string;
};

export type PedidoDeConfirmacaoApi = {
  readonly titulo: string;
  readonly descricao: string;
  readonly rotuloConfirmar?: string;
  readonly rotuloCancelar?: string;
  readonly tomConfirmar?: TomDoConfirmar;
  readonly textoParaConfirmar?: string;
};

type ApiDeDialogos = {
  readonly avisar: (pedido: PedidoDeAvisoApi) => Promise<void>;
  readonly confirmar: (pedido: PedidoDeConfirmacaoApi) => Promise<boolean>;
};

let api: ApiDeDialogos | null = null;

/** Liga a API imperativa ao ProvedorDeDialogos montado. */
export function ligarDialogosDoApp(proxima: ApiDeDialogos | null): void {
  api = proxima;
}

/**
 * Aviso modal (substitui window.alert).
 * Prefira `useDialogos().avisar` em componentes.
 */
export function avisar(pedido: PedidoDeAvisoApi): Promise<void> {
  if (!api) {
    return avisarComoFallback(pedido);
  }
  return api.avisar(pedido);
}

/**
 * Confirmacao modal (substitui window.confirm).
 * Prefira `useDialogos().confirmar` em componentes.
 */
export function confirmar(pedido: PedidoDeConfirmacaoApi): Promise<boolean> {
  if (!api) {
    return confirmarComoFallback(pedido);
  }
  return api.confirmar(pedido);
}

/** Fallback de teste/SSR: resolve sem UI (nao usa window.alert). */
export async function avisarComoFallback(
  _pedido: PedidoDeAvisoApi,
): Promise<void> {
  return;
}

/** Fallback de teste/SSR: cancela (nao usa window.confirm). */
export async function confirmarComoFallback(
  _pedido: PedidoDeConfirmacaoApi,
): Promise<boolean> {
  return false;
}
